// extracted by mini-css-extract-plugin
export default {"dropdown":"oBGsdZp5VlreoTJoA_Gr"};